import { SEARCH_TERM, SET_ROUTE } from './actions'

export function search (
  state = {
    searchTerm: ''
  },
  action
) {
  switch (action.type) {
    case SEARCH_TERM:
      return Object.assign({}, state, {
        searchTerm: action.searchTerm
      })
    default:
      return state
  }
}

export function routes (
  state = {
    matches: []
  },
  action
) {
  switch (action.type) {
    case SET_ROUTE:
      return Object.assign({}, state, {
        matches: action.matches
      })
    default:
      return state
  }
}
